export default __webpack_public_path__ + "static/media/background_fourth_section.7ff5c41b.jpeg";